import home from './Home.png'
import secure_tech from './secure_tech.png'
import secura_logo from './secura_logo.png'
import securite from './securite.png'
import security from './security.png'
import deconnexion from './deconnexion.png'
import carte from './carte.png'

import pointages from './Pointages.png'
import conges from './congé.png'
import absences from './Absences.png'
import rapport from './Rapport.png'

import horaires from './Horaires.png'
import horaire from './Horaire.png'
import employes from './Employés.png'
import cartes from './cartes.png'
import projets from './projets.png'
import retards from './Retards.png'
import presences from './Présences.png'
import departements from './Departements.png'
import parametres from './parametres.png'
import localisation from './Localisation.png'
import loca from './loca.png'
import Noti from './Noti.png'
import R from './R.png'
import pointageInterSite from './Pointage inter-site.png'

/** Logo principal Secura (wordmark) — splash, sidebar, branding. */
export const logoSecura = secura_logo;

export const assets = {
    home,
    /** @deprecated préférer logoSecura / assets.secura_logo */
    secure_tech,
    secura_logo,
    securite,
    security,
    deconnexion,
    carte,
    pointages,
    conges,
    absences,
    rapport,
    horaires,
    horaire,
    employes,
    cartes,
    projets,
    retards,
    presences,
    departements,
    parametres,
    localisation,
    loca,
    Noti,
    R,
    pointageInterSite,
}
